export default {
  oilList:'api/oil_packages/',
  packageList:'api/service_package_types/',
  servePost:"/api/service_applies/",
  storeInfo:"/api/store_infos/",
  insurceApi:"/api/insurance_applies/",
  partnerApi:'/api/partner_applies/',
  postCode:"/api/wx_login_gzh/",
  getUserInfo:"/api/user_info/"
}